import CompanyForm from '@/views/App/AddressBook/Company/Form.vue';
import CompanyList from '@/views/App/AddressBook/Company/List.vue';
import DoctorForm from '@/views/App/AddressBook/Doctor/Form.vue';
import DoctorList from '@/views/App/AddressBook/Doctor/List.vue';
import ClientForm from '@/views/App/AddressBook/Client/Form.vue';
import ClientList from '@/views/App/AddressBook/Client/List.vue';
import PrivateCustomerForm from '@/views/App/AddressBook/PrivateCustomer/Form.vue';
import PrivateCustomerList from '@/views/App/AddressBook/PrivateCustomer/List.vue';
import PartnerPracticesForm from '@/views/App/AddressBook/PartnerPractices/Form.vue';
import PartnerPracticesList from '@/views/App/AddressBook/PartnerPractices/List.vue';

const routesAddressBook = [
    // COMPANY
    {
        path: 'company/list',
        name: 'addressBookCompanyList',
        component: CompanyList
    },
    {
        path: 'company/form/:id?',
        name: 'addressBookCompanyForm',
        component: CompanyForm
    },

    // CLIENT
    {
        path: 'client/list',
        name: 'addressBookClientList',
        component: ClientList
    },
    {
        path: 'client/form/:id?',
        name: 'addressBookClientForm',
        component: ClientForm
    },

    // DOCTOR
    {
        path: 'doctor/list',
        name: 'addressBookDoctorList',
        component: DoctorList
    },
    {
        path: 'doctor/form/:id?',
        name: 'addressBookDoctorForm',
        component: DoctorForm
    },

    // PRIVATE CUSTOMER
    {
        path: 'private-customer/list',
        name: 'addressBookPrivateCustomerList',
        component: PrivateCustomerList
    },
    {
        path: 'private-customer/form/:id?',
        name: 'addressBookPrivateCustomerForm',
        component: PrivateCustomerForm
    },

    // PARTNER PRACTICE
    {
        path: 'partner-practices/list',
        name: 'addressBookPartnerPracticesList',
        component: PartnerPracticesList
    },
    {
        path: 'partner-practices/form/:id?',
        name: 'addressBookPartnerPracticesForm',
        component: PartnerPracticesForm
    },
];

export default routesAddressBook;